import { EMPTY_STRING } from '../../../../React/Common/Constants/Separators'

/** Scope filter values aligned with backend (CActionAdminEntityListCode). */
export const SCOPE_ALL: string = EMPTY_STRING
export const SCOPE_SERVICEWIDE: string = '1'
export const SCOPE_SYSTEMWIDE: string = '2'
export const SCOPE_DETACHED: string = '10'

/** Code type filter values: Account (0), ACD Not Available (10). All is represented by {@link EMPTY_STRING}. */
export const CODE_TYPE_ACCOUNT: string = '0'
export const CODE_TYPE_ACD_NOT_AVAILABLE: string = '10'

/** Pagination defaults. */
export const FIRST_PAGE_INDEX: number = 0
export const DEFAULT_ROWS_PER_PAGE_OPTIONS: number[] = [10, 25, 50, 100]
